/* @flow */

export const NEWS_TARGET_CLEARED: string = 'news@diffusion:NEWS_TARGET_CLEAR';
export const NEWS_TARGETS_UPDATED: string =
  'news@diffusion:NEWS_TARGETS_UPDATED';

export const updateTargets = targets => ({
  type: NEWS_TARGETS_UPDATED,
  targets,
});

export const clearTarget = () => ({
  type: NEWS_TARGET_CLEARED,
});



// WEBPACK FOOTER //
// ./src/modules/news/actions/diffusion.js